import angular from 'angular';
import { CashRegisterReconciliation } from '@alquilatucancha/backoffice-integration';

const moduleName = 'atc-cash-register-reconciliation';

angular.module(moduleName, []).directive('cashRegisterReconciliation', [
    'Backoffice',
    'Club',
    (Backoffice, Club) => ({
        restrict: 'A',
        link: (scope, el) => {
            Backoffice.renderComponent(el[0], CashRegisterReconciliation, {
                onStateChange: (state) => {
                    Club.setCashRegisterReconciliationState(state);
                },
            });

            scope.$on('$destroy', () => {
                Backoffice.unmountComponent?.(el[0]);
            });
        },
    }),
]);

export default moduleName;
